import { SegmentType } from '../../../common/entities/segment.type';
import { FilterSettingItem } from '../../entities/user-preferences/user-preferences';

/** Name the patient side panel saves its setting under in the user preferences */
export const PATIENT_SIDE_PANEL_SETTING_NAME = 'PatientSidePanel';

/**
 * What the patient side panel keeps in the user preferences: the tab it was left on, which the panel of every page
 * about a patient opens on again, also after a reload.
 */
export class PatientSidePanelSetting extends FilterSettingItem {
    activeTab: SegmentType;

    constructor(activeTab: SegmentType) {
        super(PATIENT_SIDE_PANEL_SETTING_NAME);
        this.activeTab = activeTab;
    }
}
